module.exports = __webpack_public_path__ + "static/media/flow-background.f6269569.png";